import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ContentShare } from '@ifeng/ui_pc_share';
import errorBoundary from '@ifeng/errorBoundary';
import Chip from 'Chip';
import Caption from './caption';
import MainContent from './mainContent';
import Vote from './vote';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import Ppx from './ppx';
import TuanRecommendL from './tuanRecommendL';
import { rel } from '../../../../../../utils/rel';
import SeriesInfo from './seriesInfo';
import RelatedRead from './relatedRead';
import Ad from '@ifeng/ui_pc_ad';
import TxtAd from './txtAd'

const LoadComment = Loadable({
    loader: () => import('@ifeng/ui_pc_comment'),
    loading() {
        return <div />;
    },
});

class Artical extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        commentPPX: PropTypes.string,
        qrcode: PropTypes.string,
        tuanRecommendl: PropTypes.array,
        articleTopAd: PropTypes.object,
        txtAd: PropTypes.object,
        curCity: PropTypes.object,
        seriesInfo: PropTypes.object,
    };
    getShowCopyright(content){
        let { breadCrumbdata =[]} = content;
        if (breadCrumbdata[breadCrumbdata.length - 1] && (breadCrumbdata[breadCrumbdata.length - 1].title == "全媒体" || breadCrumbdata[breadCrumbdata.length - 1].title =="汽车资讯")){
            return true;
        }
        return false;
    }
    render() {
        const { content, articleTopAd, txtAd,  commentPPX, qrcode, tuanRecommendl, curCity, seriesInfo } = this.props;
        const {
            allowComment,
            title,
            newsTime,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            url,
            commentUrl,
            skey,
            voteId,
            isOriginal,
            contentData,
            editorName,
            editorCode="",
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
            author,
            tags,
            tagsIsJson,
            carSeriesData,
        } = content;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        };
        const date = newsTime.split(' ')[0];
        const time = newsTime.split(' ')[1];
        const dateTime = `${date.split('-')[0]}年${date.split('-')[1]}月${date.split('-')[2]}日 ${time}`;
        const followUrl = `//gentie.ifeng.com/view.html?docUrl=${commentUrl}&docName=${title}&skey=${skey}&pcUrl=${pcUrl}`;
        const captionData = {
            title,
            url,
            dateTime,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            commentUrl,
            followUrl,
            pcUrl,
            author,
        };

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const commentConfig = {
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl,
            // 获取评论内容接口
            cmtNumUrl: '//comment.ifeng.com/get.php',
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: '//comment.ifeng.com/post.php',
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: '//comment.ifeng.com/vote.php',
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: '//comment.ifeng.com/report',
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            // 是否允许评论
            allowComment,
        };

        let isShowCopyright = this.getShowCopyright(content);
        return (
            <div className={styles.artical}>
                <div
                    className={carSeriesData && carSeriesData.length > 0 ? styles.topContent : styles.topBorderContent}>
                    <div className={styles.artical_con}>
                        <Caption content={captionData} />
                        <div className={styles.articleTopAd_box}>
                            <Ad content={articleTopAd} styleName={styles.articleTopAd} />
                        </div>
                        <MainContent shareInfo={shareInfo} content={contentData} pluginData={pluginData} />
                        <div className={styles.artical_line}></div>
                        {isShowCopyright&&<div className={styles.copyrightBox} >“特别声明：以上作品内容(包括在内的视频、图片或音频)为凤凰网旗下自媒体平台“大风号”用户上传并发布，本平台仅提供信息存储空间服务。<br/>Notice: The content above (including the videos, pictures and audios if any) is uploaded and posted by the user of Dafeng Hao, which is a social media platform and merely provides information storage space services.”</div>}
                        <div className="clear" />
                        <div className={styles.vote_box}>
                            {editorName ? (
                                <p className={styles.author}>{`[责任编辑：${editorName} ${editorCode}]`}</p>
                            ) : (
                                ''
                            )}
                            {isOriginal !== '0' ? (
                                <p className={styles.copyrightInfo}>(本文章版权归凤凰网所有，未经授权，不得转载)</p>
                            ) : (
                                ''
                            )}
                            <div className="clear" />
                        </div>
                        <TxtAd content={txtAd}/>
                        <Vote voteId={voteId} />
                        <div className={styles.share_box}>
                            <ContentShare shareInfo={shareInfo} />
                        </div>
                        <div className={styles.space10} />
                        <div id='articleBottomAdAuto'></div>
                        {qrcode ? (
                            <Chip
                                id="40004"
                                type="static"
                                title="文章二维码推荐"
                                groupName="头部"
                                user="dev"
                                content={qrcode}>
                                <Ppx />
                            </Chip>
                        ) : (
                            ''
                        )}{' '}

                        {tags && tags.length>0 ? (
                            <div className={styles.arllabel}>
                                <span>文章标签：</span>
                                <ul className={styles.alst}>
                                    {tags
                                        .splice(0, 10)
                                        .map((item, index) => <li key={index}>{tagsIsJson ? item[0] : item}</li>)}
                                </ul>
                                <div className="clear" />
                            </div>
                        ) : null}
                        {carSeriesData && carSeriesData.length > 0 && tuanRecommendl ? (
                            <Chip
                                id="55001"
                                type="recommend"
                                title="正文好书精选"
                                groupName="正文"
                                position="relative"
                                content={tuanRecommendl}
                                translate="handleGoodbookData">
                                <TuanRecommendL />
                            </Chip>
                        ) : (
                            ''
                        )}
                    </div>
                    {carSeriesData && carSeriesData.length > 0 ? <RelatedRead content={carSeriesData} /> : ''}
                </div>
                <div className={styles.arlback}>
                    <a href="//auto.ifeng.com" target="_blank" rel={rel}>
                        返回凤凰网汽车首页&gt;&gt;
                    </a>
                </div>
                {carSeriesData && carSeriesData.length > 0 && curCity ? (
                    <SeriesInfo content={carSeriesData} curCity={curCity} seriesInfo={seriesInfo} />
                ) : (
                    ''
                )}
                <div className={styles.comment_box}>
                    <LazyLoad>
                        <LoadComment articleInfo={commentConfig} />
                    </LazyLoad>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Artical);
